(function () {
  // Mobiel menu
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // Productgalerij
  var main = document.getElementById('main-img');
  var thumbs = document.querySelectorAll('[data-full]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = t.getAttribute('data-full');
      main.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    });
  });

  // Offertedatum: minstens 2 dagen vooruit
  document.querySelectorAll('input[data-min-days]').forEach(function (el) {
    var d = new Date();
    d.setDate(d.getDate() + parseInt(el.getAttribute('data-min-days'), 10));
    var iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    el.min = iso;
  });

  // Taalkeuze (NL / EN / FR) via Google Translate
  function readLang() {
    var m = document.cookie.match(/googtrans=\/nl\/(en|fr)/);
    return m ? m[1] : 'nl';
  }
  function setLang(l) {
    var past = 'expires=Thu, 01 Jan 1970 00:00:00 GMT;';
    var val = l === 'nl' ? '' : '/nl/' + l;
    var host = location.hostname;
    ['', 'domain=' + host + ';', 'domain=.' + host.replace(/^www\./, '') + ';'].forEach(function (d) {
      document.cookie = 'googtrans=' + val + ';path=/;' + d + (l === 'nl' ? past : '');
    });
    location.reload();
  }
  var current = readLang();
  document.querySelectorAll('[data-lang]').forEach(function (b) {
    b.setAttribute('aria-pressed', b.getAttribute('data-lang') === current);
    b.addEventListener('click', function () { setLang(b.getAttribute('data-lang')); });
  });
  if (current !== 'nl') {
    window.googleTranslateElementInit = function () {
      new google.translate.TranslateElement({ pageLanguage: 'nl', includedLanguages: 'nl,en,fr', autoDisplay: false }, 'google_translate_element');
    };
    var s = document.createElement('script');
    s.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(s);
  }
})();

// Offerteformulier: kalender + nette samenvatting. Herstartbaar, zodat het ook
// werkt in de thema-editor (daar worden secties opnieuw geladen).
(function () {
  var MONTHS = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
  var DAYS = ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];
  var HEAD = ['ma','di','wo','do','vr','za','zo'];
  function pad(n) { return String(n).padStart(2, '0'); }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parse(s) {
    s = (s || '').trim();
    var m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
    m = s.match(/^(\d{1,2})[-\/.](\d{1,2})[-\/.](\d{4})$/);
    if (m) return new Date(+m[3], +m[2] - 1, +m[1]);
    return null;
  }
  function label(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }

  function initCalendar(root) {
    var form = root.closest('form');
    var fallback = document.getElementById('q-datum');
    var status = document.getElementById('cal-status');
    var error = document.getElementById('cal-error');
    var minDays = parseInt(root.getAttribute('data-min-days'), 10);
    if (isNaN(minDays)) minDays = 2;
    var monthsAhead = parseInt(root.getAttribute('data-months'), 10) || 6;
    var closed = (root.getAttribute('data-closed') || '').split(',').filter(Boolean).map(Number);

    // Verborgen veld neemt de plaats in van het gewone datumveld
    var input = document.createElement('input');
    input.type = 'hidden'; input.id = 'q-datum'; input.name = 'contact[Gewenste datum]';
    if (fallback) fallback.remove();
    root.parentNode.insertBefore(input, root);

    var booked = {};
    var src = document.getElementById('cal-booked');
    (src ? src.textContent : '').split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var parts = line.split(/\s+(?:tot|t\.e\.m\.|to|-|\u2013)\s+/i);
      var a = parse(parts[0]);
      var b = parts[1] ? parse(parts[1]) : a;
      if (!a || !b) return;
      if (b < a) { var t = a; a = b; b = t; }
      var n = 0;
      for (var d = new Date(a); d <= b && n < 400; d.setDate(d.getDate() + 1), n++) booked[key(d)] = true;
    });

    var today = new Date(); today.setHours(0, 0, 0, 0);
    var first = new Date(today); first.setDate(first.getDate() + minDays);
    var last = new Date(today.getFullYear(), today.getMonth() + monthsAhead + 1, 0);
    var view = new Date(today.getFullYear(), today.getMonth(), 1);
    var selected = '';

    function render() {
      root.innerHTML = '';
      var bar = document.createElement('div'); bar.className = 'cal-bar';
      var prev = document.createElement('button'); prev.type = 'button'; prev.textContent = '\u2039'; prev.setAttribute('aria-label', 'Vorige maand');
      var next = document.createElement('button'); next.type = 'button'; next.textContent = '\u203A'; next.setAttribute('aria-label', 'Volgende maand');
      var title = document.createElement('strong'); title.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
      prev.disabled = view.getFullYear() === today.getFullYear() && view.getMonth() === today.getMonth();
      next.disabled = new Date(view.getFullYear(), view.getMonth() + 1, 1) > last;
      prev.onclick = function () { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render(); };
      next.onclick = function () { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render(); };
      bar.appendChild(prev); bar.appendChild(title); bar.appendChild(next);
      root.appendChild(bar);

      var grid = document.createElement('div'); grid.className = 'cal-grid';
      HEAD.forEach(function (h) { var c = document.createElement('span'); c.className = 'cal-head'; c.textContent = h; grid.appendChild(c); });
      var offset = (new Date(view.getFullYear(), view.getMonth(), 1).getDay() + 6) % 7;
      for (var i = 0; i < offset; i++) grid.appendChild(document.createElement('span'));
      var days = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      for (var day = 1; day <= days; day++) {
        var d = new Date(view.getFullYear(), view.getMonth(), day);
        var k = key(d);
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'cal-day'; btn.textContent = day;
        var why = '';
        if (d < first || d > last) why = 'niet beschikbaar';
        else if (closed.indexOf(d.getDay()) !== -1) why = 'gesloten';
        else if (booked[k]) why = 'volgeboekt';
        if (why) {
          btn.disabled = true;
          if (why === 'volgeboekt') btn.classList.add('is-booked');
          btn.setAttribute('aria-label', label(d) + ', ' + why);
        } else {
          btn.setAttribute('aria-label', label(d));
          btn.setAttribute('aria-pressed', k === selected ? 'true' : 'false');
          if (k === selected) btn.classList.add('is-selected');
          btn.onclick = (function (date, kk) { return function () {
            selected = kk; input.value = label(date);
            if (status) status.textContent = 'Gekozen datum: ' + label(date);
            if (error) error.hidden = true;
            render();
          }; })(d, k);
        }
        grid.appendChild(btn);
      }
      root.appendChild(grid);
      var legend = document.createElement('p'); legend.className = 'cal-legend';
      legend.innerHTML = '<span class="dot"></span> gekozen &nbsp; <span class="dot booked"></span> volgeboekt &nbsp; <span class="dot off"></span> niet beschikbaar';
      root.appendChild(legend);
    }
    render();

    form.addEventListener('submit', function (e) {
      if (!input.value) {
        e.preventDefault();
        if (error) error.hidden = false;
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  function initSummary(form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      function v(name) {
        var el = form.querySelector('[name="contact[' + name + ']"]');
        return el && el.value ? el.value.trim() : '-';
      }
      var body = form.querySelector('[name="contact[body]"]');
      if (!body || body.getAttribute('data-done')) return;
      var extra = body.value.trim();
      body.value =
        'OFFERTEAANVRAAG\n' +
        '----------------------------\n' +
        'Naam: ' + v('name') + '\n' +
        'E-mail: ' + v('email') + '\n' +
        'Telefoon: ' + v('phone') + '\n\n' +
        'WAGEN\n' +
        'Merk en model: ' + v('Merk') + ' ' + v('Model') + '\n' +
        'Bouwjaar: ' + v('Bouwjaar') + '\n' +
        'Motortype: ' + v('Motortype') + '\n' +
        'Chassisnummer: ' + v('Chassisnummer') + '\n\n' +
        'AFSPRAAK\n' +
        'Gewenste datum: ' + v('Gewenste datum') + '\n\n' +
        'WAT MOET ER GEBEUREN?\n' + (extra || '-');
      body.setAttribute('data-done', '1');
    });
  }

  function initQuote() {
    var root = document.getElementById('cal');
    var form = document.getElementById('quote-form');
    if (!root || !form || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    initCalendar(root);   // eerst: controle op datum
    initSummary(form);    // daarna: samenvatting in het bericht
  }
  initQuote();
  document.addEventListener('shopify:section:load', initQuote);
})();
